const SEND_OTP_URL = "/login/send_otp";
const VERIFY_OTP = "/login/verify_otp";
const VERIFY_FR = "/login/verify_fr";
const FETCH_EMPLOYEES = "/fetch_employees";
const FETCH_CURRENT_USER = "/get_admin";

export const SEND_EMAIL_OTP = "/send_email_otp";
export const VERIFY_EMAIL_OTP = "/verify_email_otp";
export const RESEND_EMAIL_OTP = "/resend_email_otp";
export const RESEND_MOBILE_OTP = "/resend_otp";

export const SEND_MOBILE_OTP = "/send_otp";
export const VERIFY_MOBILE_OTP = "/verify_otp";

export const SUBMIT_PROFESSIONAL_DETAILS = "/submit_professional_details";
export const FR_REGISTRATION = "/fr_registration";
export const SIGNUP_UPLOAD_DOCUMENTS = "/upload_documents";
export const SIGNUP_SUBMIT_BANK_DETAILS = "/submit_bank_details";
export const SIGNUP_SUBMIT_EDUCATION_DETAILS = "/submit_education_details";

export const SIGNUP_FETCH_ALL_EDUCATIONS = "/fetch_all_educations";
export const SIGNUP_FETCH_ALL_LANGUAGES = "/fetch_all_languages";
export const SIGNUP_FETCH_ALL_LOCATIONS = "/fetch_locations_list";

export const SIGNUP_FETCH_ALL_CATEGORY_SKILLS = "/get_catergory_skills"
export const SIGNUP_SUBMIT_EMPLOYEE_SKILLS = "/submit_employee_skills";

export const SIGNUP_SUBMIT_LOCATION_DATA = "/submit_location_data";
export const SIGNUP_FETCH_ADHAR_DETAILS = "/get_personal_details";

export const SIGNUP_FETCH_PERSONAL_DETAILS = "/get_personal_details";

export const DOWNLOAD_ADHAR_FRONT = "/download_aadhaar_front";
export const DOWNLOAD_ADHAR_BACK = "/download_aadhaar_back";

export const GET_STORED_FILE = "/get_stored_file";

export const STORE_JOB_ID = "/amt/store_job_id";

export const CLEAR_REGISTRATION_PROCESS = "/clear_registration_process";
export const VALIDATE_CROWDSOURCE_PHONE_NUMBER = "/validate_phone_number";
export const INITATE_STATIC_FLOW = "/initiate_static_flow";
export const DOWNLOAD_REGISTRATION_STATS = "/download_registration_stats";

export const GET_WORK_FROM_HOME_STATS = "/get_work_from_home_stats";
export const CANCEL_WORK_FROM_HOME_REQUEST = "/cancel_work_from_home_request";

export const CANCEL_WITHDRAWL_REQUEST_BY_USER = "/cancel_withdrawal_request";
export const REJECT_WITHDRAWL_REQUEST_BY_ADMIN = "/reject_withdrawal_request";

export const MIGRATE_USER = "/migrate_user";

export const COMPENSATION_CONFIG_LIST = "/compensation_configs_list";
export const UPDATE_COMPENSATION_CONFIGS = "/update_compensation_configs";

export const FETCH_EMPLOYEE_JOB_IDS = "/get_employee_job_ids";
export const FETCH_PAYMENT_ACCESS = "/get_payment_access";

// PROFILING
export const FETCH_PROFILING_ANALYTICS = "/profiling_analytics";
export const FETCH_AET_COMPETENCY_ASSESSMENT_LIST =
  "/competency_assessment_list";
export const FETCH_USER_BLOCK_STATUS = "/is_user_blocked";

export const COMPETENCY_ASSESSMENT_BLOCK_USER = "/block_user";
export const COMPETENCY_ASSESSMENT_UNBLOCK_USER = "/unblock_user";

export const FETCH_SIGNUP_TEAMS = "/fetch_all_teams";
export const FETCH_SIGNUP_SUB_TEAMS = "/fetch_all_sub_teams";
export const FETCH_SIGNUP_DESGINATIONS = "/fetch_all_designations";
export const FETCH_SIGNUP_ENTITIES = "/fetch_all_entities";
export const ACCEPT_SIGNUP_TERMS_AND_CONDITIONS =
  "/accept_terms_and_conditions";
export const FETCH_SIGNUP_TERMS_AND_CONDITIONS = "/terms_and_conditions";

const FETCH_WORKTYPES = "/fetch_work_types";
const FETCH_DESIGNATIONS = "/fetch_all_designations";
const FETCH_ENTITIES = "/fetch_all_entities";
const FETCH_SKILLS = "/fetch_skills";

const FETCH_PROJECTS = "/fetch_projects";
const FETCH_SUB_PROJECTS = "/fetch_sub_projects";
const FETCH_MODULES = "/get_modules_list";
const FETCH_LOCATIONS = "/fetch_locations";

const UPDATE_USER_PROFILE = "/update_user_profile";
const UPDATE_EMPLOYEE_PROFESSIONAL = "/submit_professional_details";

export const ADD_EMPLOYEE_LEAD = "/add_lead";
export const REMOVE_EMPLOYEE_LEAD = "/remove_lead";

const FETCH_EMPLOYEE_PERSONAL = "/get_employee";
const FETCH_EMPLOYEE_PROFESSIONAL = "/employee_professional_details";

const FETCH_LEAVE_APPLICATIONS = "/get_leave_application";
const FETCH_LEAVE_TYPES = "/fetch_leave_type";
const FETCH_LOP_LEAVES = "/get_lop_leaves";
const FETCH_LEAVE = "/get_leave";
const FETCH_TEAMS = "/fetch_teams";
const FETCH_USER = "/get_user";

const FETCH_JOB_MANAGEMENT_COUNTS = "/get_job_counts";
const FETCH_JOB_LISTS = "/get_jobs";
const FETCH_JOB_DETAILS = "/get_job_details";
const FETCH_USER_DETAILS_FOR_JOB = "/get_users_details_for_job";

const CONFIRM_BOOKING = "/confirm_bookings";

const FETCH_EMPLOYEE_SKILLS = "/get_employee_skills";

const FETCH_ROUTES_LIST = "/get_routes_list";
const FETCH_STOPS = "/get_stops_list";
const FETCH_VEHICLES_SUMMARY = "/get_vehicles_summary";

// ** SCHEDULE MANAGEMENT APIS STARTS HERE **

const FETCH_SCHEDULE_FULL_SLOTS = "/fetch_all_slots";
const FETCH_SCHEDULE_LOCATIONS = "/fetch_locations";
const FETCH_SCHEDULE_PROJECTS = "/fetch_projects";
const FETCH_SCHEDULE_SUB_PROJECTS = "/fetch_sub_projects";
const FETCH_EMP_SCHEDULE = "/get_all_employees_week_schedule";
const UPDATE_EMP_SCHEDULE = "/update_employees_week_schedule";
const FETCH_EMP_SCHE_LEAVES = "/employees_on_wekoff_leave";
const DOWNLOAD_EMP_SCHE_LEAVES = "/download_employees_schedules";
const FETCH_SCHEDULE_WORK_TYPES = "/fetch_work_types";
const FETCH_SCHEDULE_LEADS = "/fetch_employees";

// ** SCHEDULE MANAGEMENT APIS ENDS HERE **

const FETCH_PASSENGERS_LIST = "/get_passengers_list";

const FETCH_SLOTS = "/fetch_all_slots";
const UPDATE_ROUTE = "/update_route";
const ADD_ROUTE = "/add_route";

const FETCH_VEHICLES = "/get_vehicles_list";
const FETCH_DRIVERS = "/get_drivers_list";
const ADD_VEHICLE = "/add_vehicle";
const UPDATE_VEHICLE = "/update_vehicle";
const DELETE_VEHICLE = "/delete_vehicle";

const ADD_BOOKING = "/create_employee_booking";
const FETCH_BOOKINGS = "/get_bookings_count";
const FETCH_EMPLOYEE_BOOKINGS = "/get_employee_bookings_list";

const FETCH_EVENT_LIST = "/get_events_list";
const FETCH_EVENT = "/get_event";
const FETCH_EVENT_GROUP_LIST = "/event_groups_list";
const FETCH_EVENT_TYPES_LIST = "/event_types_list";
const FETCH_EVENT_VENUES_LIST = "/event_venues_list";
const FETCH_HOLIDAYS = "/fetch_holidays";
const FETCH_GROUP_MEMBERS = "/get_event_group_members";
const FETCH_MASTER_PROJECTS = "/get_projects_list";
const FETCH_MASTER_SUB_PROJECTS = "/get_sub_project_list";
const FETCH_MASTER_PROJECT_DETAILS = "/get_project_detail";
const FETCH_MASTER_SUBPROJECT_DETAILS = "/get_sub_project_detail";
const FETCH_MASTER_TEAMS = "/get_teams_list";
const FETCH_MASTER_SUB_TEAMS = "/get_sub_teams_list";
const FETCH_MASTER_TEAM_DETAILS = "/get_team_detail";
const FETCH_CUSTOMERS_LIST = "/get_customers_list";
const FETCH_TAGS_LIST = "/get_tags_list";

const FETCH_TRIP_ANALYTICS = "/get_trips_analytics";
const ADD_STOP = "/add_stop";
const UPDATE_STOP = "/update_stop";

const FETCH_ALL_TASKS = "/get_all_tasks";
const CREATE_NEW_TASK = "/create_task";
const UPDATE_TASK = "/update_task";
const GET_TASK_DETAILS = "/get_task_details";
const GET_ALL_TASKS = "/get_all_tasks";
const GET_REQUESTED_TASKS = "/get_requested_tasks";
const GET_ASSIGNED_TASKS = "/get_assigned_task";
const GET_TICKETS_ANALYTICS = "/get_tickets_analytics";

const FETCH_ALL_CATEGORIES = "/get_task_categories";

const FETCH_LEAVE_TYPE = "/fetch_leave_type";
const DOWNLOAD_PAYROLL_REPORT = "/download_payroll_history";
const FETCH_UNMARKEDLIST = "/unmarked_users_list";
const UPDATE_ATTEDANCE = "/update_attendance";
const UNMARKED_COUNT = "/get_unmarked_users_count";

const FETCH_DAILY_UPDATES = "/daily_update_history";
const UPDATE_DAILY_UPDATES = "/edit_daily_update";
const FETCH_CUSTOMER_ANALYTICS = "/customer_analytics";

const FETCH_CUSTOMER_WORK_HOURS = "/customer_wise_work_hrs";
const FETCH_PROJECT_WORK_HOURS = "/project_wise_work_hrs";
const FETCH_TEAM_WORK_HOURS = "/team_wise_work_hrs";
const FETCH_PROJECT_ANALYTICS = "/project_analytics";
const FETCH_TEAM_ANALYTICS = "/team_analytics";
const FETCH_EMPLOYEE_WORK_ANALYTICS = "/employee_analytics";

const FETCH_COMPANY_GOALS = "/get_company_goals";
const FETCH_TEAM_GOALS = "/get_team_goals";
const FETCH_SUBTEAM_GOALS = "/get_sub_team_goals";
const FETCH_INDIVIDUAL_GOALS = "/get_individual_goals";
const FETCH_TASKS = "/get_task_list";

const CREATE_NOTICE_BOARD = "/create_notice_board";
const UPDATE_NOTICE_BOARD = "/update_notice_board";
const NOTICEBOARD_DETAILS = "/get_notice_board";
const FETCH_NOTICEBOARD_LIST = "/get_notice_boards_list";
const CREATE_POLLINGBOARD = "/create_polling_board";
const UPDATE_POLLINGBOARD = "/update_polling_board";
const DELETE_POLLING_OPTION = "/delete_polling_option";
const POLLINGBOARD_DETAILS = "/get_polling_board";
const FETCH_POLLINGBOARD_LIST = "/get_polling_boards_list";
const CREATE_THOUGHT_BOARD = "/create_thought_of_the_day_board";
const UPDATE_THOUGHT_BOARD = "/update_thought_of_the_day_board";
const THOUGHTBOARD_DETAILS = "/get_thought_of_the_day_board";
const FETCH_THOUGHTBOARD_LIST = "/get_thought_of_the_day_boards_list";
const FECTH_ALL_TEAMS = "/fetch_all_teams";
const FECTH_ALL_SUb_TEAMS = "/fetch_all_sub_teams";
const SEND_NOTIFICATION = "/send_notification";
const FETCH_COMMENTS = "/fetch_all_comments";
const SUBMIT_COMMENT = "/send_message";
const FETCH_ALL_POLLING_LIST = "/get_polling_members_list";
const SEND_BULK_NOTIFICATION = "/send_bulk_notification";
const NEW_DAILY_UPDATE = "/new_daily_update";
const FETCH_SESSIONS_LIST = "/get_session_list";
const EDIT_UPDATE_DATA = "/edit_daily_update";
const EDIT_SUB_UPDATE_DATA = "/edit_sub_update";
const GET_DAILY_UPDATE = "/get_daily_update";
const DELETE_DAILY_UPDATE = "/delete_daily_update";
const DELETE_SUB_UPDATE = "/delete_sub_update";
const FETCH_ALL_ACKNOWLEDGE_LIST = "/get_acknowledged_members_list";
const ADD_DESIGNATION = "/add_designation";
const UPDATE_DESIGNATION = "/update_designation";
const DELETE_DESIGNATION = "/delete_designation";
const FETCH_ALL_SUB_CATEGORIES = "/get_task_sub_categories";
const ADD_INVITES = "/add_invites";
const FETCH_ALL_INVITES = "/get_invites_list";
const UPLOAD_INVITES = "/user/upload_invites";
const DOWNLOAD_INVIATATION_REPORT = "/user/download_invitation_report";
const SEND_INVITES = "/user/send_invites";
const FAILED_ATTENDANCE = "/get_failed_attendance";
const DOWNLOAD_ERROR_LOGS = "/download_error_logs";
const ADD_CATEGORY = "/add_ticket_categories";
const ADD_SUB_CATEGORY = "/add_ticket_sub_categories";
const GET_PROCUREMENT_FLOW = "get_procurement_flow_leads";
const UPDATE_PROCUREMENT_FLOW = "update_procurement_flow_leads";
const DAILY_UPDATE_HISTORY = "/daily_update_describe";
const SKILLS_SEARCH = "/skills_search";
const FETCH_ALL_TICKETS = "/get_all_tickets";
const FETCH_GROUPS = "/groups_list";
const GET_GROUP = "/get_group";
const ADD_GROUP = "/add_group";
const UPDATE_GROUP = "/update_group";
const ADD_REMOVE_GROUP_MEMBER = "/add_remove_group_members";
const DELETE_EMPLOYEE_PROJECT = "/delete_employee_project";

const FETCH_EMPLOYEESS_WITH_MODULE_ACCESS = "/get_employees_with_module_access";
const FETCH_USER_LOCATION = "/get_user_location";
const SEND_CHAT_CONVERSATION = "/chat_conversation";

const FETCH_EMPLOYEE_FILTER = "/employees_project_filter";
const INVENTORY_VIEW_QR = "/view_qr";

// New Schedule APIs
const CREATE_SCHEDULE = "/create_schedule_config";
const UPDATE_SCHEDULE_DETAILS = "/update_schedule";
const EMPLOYEES_FILTER_LIST = "/employees_filtered_list";
const CALENDAR_EVENTS = "/calender_events";
const TEAM_SCHEDULE = "/team_schedule";
const CHANGE_SHIFT = "/change_shift";
const MARK_WEEKOFF = "/mark_as_weekoff";
const MARK_LEAVE = "/mark_as_leave";
const WEEK_OFF_PREFERENCES = "/weekoff_preference_availability";
const SUBMIT_WEEKOFF_PREFERENCES = "/submit_weekoff_preferences";
const ADD_RESOURCES = "/add_resources";
const GET_WEEKOFF_LIST = "/weekoff_swap_requests_list";
const WEEKOFF_LIST_DATA = "/weekoff_swap_request_data";
const UPDATE_WEEKOFF_SWAP_DATA = "/update_weekoff_swap_request";
const LOCK_SCHEDULE = "/lock_unlock_schedule";
const ADD_RESOURCE_FILTER = "/add_resource_filter";
const REMOVE_RESOURCES = "/remove_resources";
const DELETE_SCHEDULE = "/delete_schedule";
const DELETE_SCHEDULE_CONFIG = "/delete_schedule_config";
const LEAVES_WEEKOFF_COUNT = "/leaves_weekoffs_count";
const CHANGE_WEEKOFF = "/change_weekoff";
const SCHEDULE_CONFIGS_LIST = "/schedule_configs_list";
const SCHEDULE_CONFIG_DETAILS = "/schedule_config_details";
const UPDATE_SCHEDULE = "/update_schedule_config";
const CREATE_SCHEDULE_CONFIG_DETAILS = "/create_schedule_config_details";
const FETCH_REQUESTED_RESOURCES_LIST = "/requested_resources_list";
const REQUEST_RESOURCES = "/request_resources";

const SAVE_SUBPROJECT_DASHBOARD = "/store_sub_project_dashboard";
const GET_SUBPROJECT_DASHBOARD_ATTACHMENT =
  "/get_sub_project_dashboard_attachment";
const SCHEDULED_EMPLOYEES_LIST = "/scheduled_employees_list";
const SCHEDULED_EVENT_EMPLOYEES = "/scheduled_event_employees_with_status";
const SEND_APPROVAL_REQUEST = "/send_approval_request";
const FETCH_WEEKDAYS = "/week_days_list";
const GET_SCHEDULE_CONFIG = "/get_schedule_config";
const GET_EMPLOYEES_LIST = "/get_employee_list";
const GET_DAY_WISE_SCHEDULE = "/day_wise_schedule";
const GET_UNSCHEDULED_EMPLOYEES_LIST = "/get_unscheduled_employee_list";
const DELETE_EMPLOYEE_SCHEDULE = "/delete_employee_schedule";

export const FETCH_EVENT_REQUEST_LIST = "/get_request_events_list";
export const FETCH_EVENT_REQUEST = "/scheduled_event_employees_with_status";
export const UPDATE_EVENT_REQUEST = "/update_scheduled_event_employees_status";
export const FETCH_WEEKS_RANGE_LIST = "/get_weeks_list";

// Job Scheule
export const FETCH_JOB_SCHEDULE_LIST = "/list_job_schedules";
export const UPDATE_JOB_SCHEDULE = "/update_job_schedule";
export const FETCH_JOB_SCHEDULE = "/get_job_schedule";
export const CREATE_JOB_SCHEDULE = "/create_job_schedule";
export const FETCH_CURATION_TYPES_LIST = "/list_curation_types";
export const FETCH_DATA_TYPES_LIST = "/list_data_types";

export const DOWNLOAD_PAYMENTS_REQUESTS_LIST = "/download_payments_list";
export const DOWNLOAD_PAYMENTS_LIST_BY_JOB_ID_REQUEST = "/download_payments_list_by_job_id";

export const DOWNLOAD_PENDING_PAYMENTS_LIST =
  "/download_withdrawal_requests_list";
export const DOWNLOAD_PAYMENT_HISTORY_REQUESTS_LIST =
  "/download_payment_transaction_list";
export const ANCHOR_JOBS_LIST = "/anchor_jobs_list";

export const FETCH_BANKING_DETAILS_LIST = "/bank_details_list";
export const DOWNLOAD_BANK_DETAILS_LIST = "/download_bank_details_list";

//Leave Approval
const LEAVE_APPROVAL_WORKFLOW_LIST = "/list_leave_approval_workflows";
const ADD_LEAVE_APPROVAL_WORKFLOW_EMPLOYEES =
  "/add_leave_approval_workflow_employee_mapping";
const FETCH_EMPLOYEE_WORKFLOW_MAPPINGS =
  "/get_leave_approval_workflow_employee_mappings";
const DELETE_LEAVE_WORKFLOW_MAPPINGS =
  "/delete_leave_approval_workflow_employee_mapping";

// AMT Chat URLS

export const ADD_API_CURL = "/add_api_curl";
export const ADD_API_COLLECTION = "/add_api_collection";
export const FETCH_BOTS_APIS_LIST = "/bots_apis_list";
export const FETCH_BOTS_LIST = "/bots_list";
export const SEND_AGENT_CHAT = "/agent_chat";
export const FETCH_BOT_LOGO = "/get_bot_logo";
export const FETCH_BOT_DETAILS = "/bot_details";
export const TEST_API = "/test_api";
export const UPLOAD_BOT_LOGO = "/upload_bot_logo";
export const UPDATE_API_CURL_DETAILS = "/update_api_details";
export const UPDATE_API_CURL_ACTION = "/update_api_action";
export const ADD_FILES_COLLECTION = "/add_files_collection";
export const FETCH_FILES_COLLECTION_LIST = "/files_collections_list";
export const WEBSOCKET_AGENT_CHAT = "/ws/agent-chat";
export const AMT_CHAT_VERIFY_FR = "/verify_fr";
export const GET_DEMO_DETAILS = "/bfsi/get_demo_details";
export const FETCH_CHAT_HISTORY = "/amt/get_chat_history";
export const FETCH_SIGNUP_STATUS = "/get_signup_status";
export const FETCH_SIGNUP_FLOW_STATUS = "/get_signup_flow";

export const SIGNUP_QR_CODE = "/get_qr_image";
export const GET_THREAD_HISTORY = "/amt/get_thread_history";
export const GET_THREADS_LIST = "/amt/get_thread_list";
export const GET_CHATROOMS_LIST = "/amt/get_chat_room_list";
export const READ_THREAD_MESSAGES = "/amt/read_thread_messages";
export const CLOSE_THREAD = "/amt/close_thread";
export const FETCH_WORK_FROM_HOME_AVAILABILITY = "/work_from_home_availability";
export const FETCH_EMPLOYEE_WORK_FROM_HOME_REQUESTS =
  "/get_employee_work_from_home_requests";
export const DOWNLOAD_WORK_FROM_STATS = "/download_work_from_home_stats";

export const CREATE_WITHDRAWAL_REQUEST = "/create_withdrawal_request";
export const VALIDATE_AMOUNT = "/validate_amount";
export const GET_WALLET_STATS = "/get_wallet_stats";

export const FETCH_CURATION_LIST = "/get_curation_list";
export const FETCH_COMPETENCY_ASSESSMENT_LIST = "/competency-assessments";

const GET_EARNINGS = "/payments_list";
export const FETCH_WITHDRAWAL_REQUESTS = "/withdrawal_requests_list";
const DOWNLOAD_EARNINGS = "/download_earnings";
export const DOWNLOAD_PAYMENTS_LIST = "/download_payments_list";
export const INITIATE_PAYOUT = "/initiate_payout";
export const INITIATE_BATCH_PAYOUT = "/initiate_batch_payout";
export const GET_TRANSFER_MODES = "/get_transfer_modes";
export const RETRY_INITIATE_PAYOUT = "/retry_payout";

export const FETCH_PAYOUT_STATUS = "/get_payout_status";
export const FETCH_MULTIPLE_PAYOUT_STATUS = "/get_batch_payout_status";
export const FETCH_UN_PAID_PAYMENT_LIST = "/unpaid_payments_list";
export const FETCH_PENDING_TDS_PAYEMENT_LIST = "/get_pending_tds_list";

export const DOWNLOAD_CROWDSOURCE_EARNINGS = "/download_earnings";
export const FETCH_CROWD_SOURCE_TRANSACTION_HISTORY =
  "/get_payment_transaction_list";
export const FETCH_CROWD_SOURCE_TRANSACTION_DETAILS =
  "/get_transaction_details";

export const FETCH_USER_TYPES = "/get_user_types";

export const FETCH_CROWD_SOURCE_REGISTRATION_STATS = "/get_registration_stats";

export const FETCH_CROWD_SOURCE_PENDING_REGISTRATION_EMPOLYEE_LIST =
  "/pending_registration_empoloyees_list";

// BROADCAST APIS
export const POST_BROADCAST_MESSAGE = "/broadcast_message";
export const FETCH_BROADCAST_MESSAGE_LIST = "/list_broadcast_messages";
export const UPDATE_BROADCAST_MESSAGE = "/update_broadcast_message";
export const FETCH_BROADCAST_MESSAGE = "/get_broadcast_message";
export const GET_BROADCAST_MESSAGE_TYPES = "/get_broadcast_message_types";

// ATTENDANCE APIS
export const ATTENDANCE_HISTORY = "/attendance_history";
export const MARK_ATTENDANCE = "/mark_attendance";

// AMT Chat URLS

export const CREATE_ACXIO_HUB_ROOM = "/create_chat_room";
export const UPDATE_ACXIO_HUB_ROOM = "/update_chat_room";
export const DELETE_ACXIO_HUB_ROOM = "/amt/delete_chat_room";
export const GET_ACXIO_HUB_ROOMS = "/get_chat_room_list";

export const COMPETENCY_ASSESSMENT_EXPORT = "/competency_assessment_export";

export {
  FETCH_ALL_CATEGORIES,
  FETCH_DAILY_UPDATES,
  FETCH_ALL_TASKS,
  CREATE_NEW_TASK,
  UPDATE_DAILY_UPDATES,
  UPDATE_TASK,
  GET_TASK_DETAILS,
  GET_ALL_TASKS,
  GET_REQUESTED_TASKS,
  GET_ASSIGNED_TASKS,
  GET_TICKETS_ANALYTICS,
  FETCH_EMPLOYEE_BOOKINGS,
  FETCH_BOOKINGS,
  ADD_STOP,
  UPDATE_STOP,
  ADD_BOOKING,
  ADD_VEHICLE,
  FETCH_SLOTS,
  UPDATE_VEHICLE,
  FETCH_DRIVERS,
  FETCH_VEHICLES,
  DELETE_VEHICLE,
  ADD_ROUTE,
  FETCH_STOPS,
  UPDATE_ROUTE,
  FETCH_ROUTES_LIST,
  FETCH_JOB_MANAGEMENT_COUNTS,
  FETCH_JOB_LISTS,
  FETCH_USER_DETAILS_FOR_JOB,
  FETCH_JOB_DETAILS,
  FETCH_VEHICLES_SUMMARY,
  UPDATE_USER_PROFILE,
  UPDATE_EMPLOYEE_PROFESSIONAL,
  FETCH_PASSENGERS_LIST,
  SEND_OTP_URL,
  VERIFY_OTP,
  VERIFY_FR,
  FETCH_EMPLOYEES,
  FETCH_CURRENT_USER,
  FETCH_DESIGNATIONS,
  FETCH_SKILLS,
  FETCH_PROJECTS,
  FETCH_SUB_PROJECTS,
  FETCH_MODULES,
  FETCH_LOCATIONS,
  FETCH_WORKTYPES,
  FETCH_ENTITIES,
  FETCH_EMPLOYEE_PERSONAL,
  FETCH_EMPLOYEE_PROFESSIONAL,
  FETCH_LEAVE_APPLICATIONS,
  FETCH_LOP_LEAVES,
  FETCH_TEAMS,
  FETCH_USER,
  CONFIRM_BOOKING,
  FETCH_EMPLOYEE_SKILLS,
  FETCH_EVENT_LIST,
  FETCH_EVENT,
  FETCH_EVENT_GROUP_LIST,
  FETCH_EVENT_TYPES_LIST,
  FETCH_EVENT_VENUES_LIST,
  FETCH_GROUP_MEMBERS,
  FETCH_HOLIDAYS,
  FETCH_MASTER_PROJECTS,
  FETCH_MASTER_SUB_PROJECTS,
  FETCH_MASTER_PROJECT_DETAILS,
  FETCH_MASTER_SUBPROJECT_DETAILS,
  FETCH_MASTER_TEAMS,
  FETCH_MASTER_SUB_TEAMS,
  FETCH_MASTER_TEAM_DETAILS,
  FETCH_CUSTOMERS_LIST,
  FETCH_TAGS_LIST,
  FETCH_TRIP_ANALYTICS,
  // ** SCHEDULE MANAGEMENT APIS **
  FETCH_SCHEDULE_FULL_SLOTS,
  FETCH_SCHEDULE_LOCATIONS,
  FETCH_SCHEDULE_PROJECTS,
  FETCH_SCHEDULE_SUB_PROJECTS,
  FETCH_EMP_SCHEDULE,
  UPDATE_EMP_SCHEDULE,
  FETCH_EMP_SCHE_LEAVES,
  DOWNLOAD_EMP_SCHE_LEAVES,
  FETCH_SCHEDULE_WORK_TYPES,
  FETCH_SCHEDULE_LEADS,
  // ** SCHEDULE MANAGEMENT APIS END HERE **
  FETCH_LEAVE_TYPE,
  DOWNLOAD_PAYROLL_REPORT,
  FETCH_UNMARKEDLIST,
  UPDATE_ATTEDANCE,
  UNMARKED_COUNT,
  FETCH_CUSTOMER_ANALYTICS,
  FETCH_CUSTOMER_WORK_HOURS,
  FETCH_PROJECT_WORK_HOURS,
  FETCH_TEAM_WORK_HOURS,
  FETCH_PROJECT_ANALYTICS,
  FETCH_TEAM_ANALYTICS,
  FETCH_EMPLOYEE_WORK_ANALYTICS,
  // ** GOAL MANAGEMENT APIS **
  FETCH_COMPANY_GOALS,
  FETCH_TEAM_GOALS,
  FETCH_SUBTEAM_GOALS,
  FETCH_INDIVIDUAL_GOALS,
  FETCH_TASKS,
  // NOTICE BOARD
  CREATE_NOTICE_BOARD,
  UPDATE_NOTICE_BOARD,
  NOTICEBOARD_DETAILS,
  FETCH_NOTICEBOARD_LIST,
  CREATE_POLLINGBOARD,
  UPDATE_POLLINGBOARD,
  POLLINGBOARD_DETAILS,
  FETCH_POLLINGBOARD_LIST,
  DELETE_POLLING_OPTION,
  CREATE_THOUGHT_BOARD,
  UPDATE_THOUGHT_BOARD,
  THOUGHTBOARD_DETAILS,
  FETCH_THOUGHTBOARD_LIST,
  FECTH_ALL_TEAMS,
  SEND_NOTIFICATION,
  FETCH_COMMENTS,
  SUBMIT_COMMENT,
  FECTH_ALL_SUb_TEAMS,
  FETCH_ALL_POLLING_LIST,
  SEND_BULK_NOTIFICATION,
  NEW_DAILY_UPDATE,
  FETCH_SESSIONS_LIST,
  EDIT_UPDATE_DATA,
  EDIT_SUB_UPDATE_DATA,
  GET_DAILY_UPDATE,
  DELETE_DAILY_UPDATE,
  DELETE_SUB_UPDATE,
  FETCH_ALL_ACKNOWLEDGE_LIST,
  ADD_DESIGNATION,
  UPDATE_DESIGNATION,
  DELETE_DESIGNATION,
  FETCH_ALL_SUB_CATEGORIES,
  ADD_INVITES,
  FETCH_ALL_INVITES,
  UPLOAD_INVITES,
  DOWNLOAD_INVIATATION_REPORT,
  SEND_INVITES,
  FAILED_ATTENDANCE,
  DOWNLOAD_ERROR_LOGS,
  ADD_CATEGORY,
  ADD_SUB_CATEGORY,
  GET_PROCUREMENT_FLOW,
  UPDATE_PROCUREMENT_FLOW,
  DAILY_UPDATE_HISTORY,
  SKILLS_SEARCH,
  FETCH_ALL_TICKETS,
  FETCH_GROUPS,
  GET_GROUP,
  ADD_GROUP,
  UPDATE_GROUP,
  ADD_REMOVE_GROUP_MEMBER,
  DELETE_EMPLOYEE_PROJECT,
  FETCH_LEAVE,
  FETCH_LEAVE_TYPES,
  FETCH_EMPLOYEESS_WITH_MODULE_ACCESS,
  FETCH_USER_LOCATION,
  SEND_CHAT_CONVERSATION,
  FETCH_EMPLOYEE_FILTER,
  INVENTORY_VIEW_QR,
  CREATE_SCHEDULE,
  EMPLOYEES_FILTER_LIST,
  CALENDAR_EVENTS,
  TEAM_SCHEDULE,
  CHANGE_SHIFT,
  MARK_WEEKOFF,
  MARK_LEAVE,
  WEEK_OFF_PREFERENCES,
  SUBMIT_WEEKOFF_PREFERENCES,
  ADD_RESOURCES,
  GET_WEEKOFF_LIST,
  WEEKOFF_LIST_DATA,
  UPDATE_WEEKOFF_SWAP_DATA,
  LOCK_SCHEDULE,
  ADD_RESOURCE_FILTER,
  REMOVE_RESOURCES,
  DELETE_SCHEDULE,
  DELETE_SCHEDULE_CONFIG,
  LEAVES_WEEKOFF_COUNT,
  CHANGE_WEEKOFF,
  SCHEDULE_CONFIGS_LIST,
  SCHEDULE_CONFIG_DETAILS,
  UPDATE_SCHEDULE,
  CREATE_SCHEDULE_CONFIG_DETAILS,
  FETCH_REQUESTED_RESOURCES_LIST,
  REQUEST_RESOURCES,
  SAVE_SUBPROJECT_DASHBOARD,
  GET_SUBPROJECT_DASHBOARD_ATTACHMENT,
  SCHEDULED_EMPLOYEES_LIST,
  SCHEDULED_EVENT_EMPLOYEES,
  SEND_APPROVAL_REQUEST,
  LEAVE_APPROVAL_WORKFLOW_LIST,
  ADD_LEAVE_APPROVAL_WORKFLOW_EMPLOYEES,
  FETCH_EMPLOYEE_WORKFLOW_MAPPINGS,
  DELETE_LEAVE_WORKFLOW_MAPPINGS,
  UPDATE_SCHEDULE_DETAILS,
  FETCH_WEEKDAYS,
  GET_SCHEDULE_CONFIG,
  GET_EMPLOYEES_LIST,
  GET_DAY_WISE_SCHEDULE,
  GET_UNSCHEDULED_EMPLOYEES_LIST,
  DELETE_EMPLOYEE_SCHEDULE,
  GET_EARNINGS,
  DOWNLOAD_EARNINGS,
};
